// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"cb87de5f","85":"4eeb50d1"}[chunkId] + ".chunk.js";
};